import type { ReactNode } from "react";

export function PhoneMockup({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`relative ${className}`}>
      <div className="relative h-[570px] w-[280px] rounded-[40px] bg-gray-900 p-3 shadow-2xl">
        <div className="relative h-full w-full overflow-hidden rounded-[32px] bg-white">
          <div className="absolute top-0 left-1/2 z-10 h-6 w-32 -translate-x-1/2 rounded-b-2xl bg-gray-900" />
          <div className="h-full w-full pt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
